<template>
  <v-container fluid>
    <!-- <v-toolbar color="orange" dense>
            <v-toolbar-title>Cadastro Usuário | 3 - Agenda do Aluno </v-toolbar-title>
        </v-toolbar> -->
    <v-divider></v-divider>
    <AppConfirma :dialogs="dialogs" @resposta="getResposta"></AppConfirma>
    <AppAlerta :snack="snack" />
    <v-spacer class="mt-4"></v-spacer>
    <v-row align="center" justify="center">
      <v-col col="12" md="12" xl="12" xs="12" sm="12">
        <v-card>
          <ValidationObserver ref="form" #default="{ handleSubmit }">
            <v-form @keyup.enter="handleSubmit(salvar)" @submit.prevent="handleSubmit(salvar)">
              <v-card-text>
                <v-row>
                  <v-col col="12" md="12" xl="12">
                    <v-text-field v-model="nome" label="Aluno" color="#FF562B" outlined disabled>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="12" md="3" xl="3">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="treinador"
                    >
                      <v-select
                        v-model="treinador"
                        :items="treinadores"
                        label="Treinador"
                        :error-messages="errors[0]"
                        item-text="nome"
                        item-value="id"
                        outlined
                        :disabled="trinador_desativado"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" md="3" xl="3">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="produto"
                    >
                      <v-select
                        v-model="produtoSelecionado"
                        :items="produtosTreinador"
                        label="Produto"
                        item-text="nome"
                        item-value="id"
                        :error-messages="errors[0]"
                        :disabled="treinadorDeselecionado"
                        outlined
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col col="12" md="3" xl="3">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="dia da semana"
                    >
                      <v-select
                        v-model="diasemana"
                        :items="diasDisponiveis"
                        label="Dia da semana"
                        color="#FF562B"
                        item-text="text"
                        item-value="value"
                        :error-messages="errors[0]"
                        :disabled="horariosIndisponiveis"
                        outlined
                      >
                      </v-select>
                      <v-alert
                        v-if="horariosIndisponiveis && produtoSelecionado != null"
                        type="warning"
                        outlined
                        class="mt-2"
                      >
                        Nenhum horário disponível para esse treinador com seu plano atual.
                      </v-alert>
                    </ValidationProvider>
                  </v-col>
                  <v-col col="12" md="3" xl="3">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="hora"
                    >
                      <v-select
                        v-model="hora"
                        :items="horasDisponiveis"
                        label="Hora"
                        item-text="text"
                        item-value="value"
                        color="#FF562B"
                        :error-messages="errors[0]"
                        :disabled="diasemana == null"
                        outlined
                      >
                      </v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="12">
                    <v-textarea
                      v-model="observacao"
                      label="Observação"
                      color="#FF562B"
                      outlined
                      multiline
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-row>
                  <v-col col="12" md="4" xl="4" sm="4">
                    <v-btn @click="cancelar()" color="grey" width="100%" dark>Cancelar</v-btn>
                  </v-col>
                  <v-col col="12" md="4" xl="4" sm="4">
                    <v-btn color="red" width="100%" dark @click="excluir()" :disabled="isDisabled"
                      >Excluir</v-btn
                    >
                  </v-col>
                  <v-col col="12" md="4" xl="4" sm="4">
                    <v-btn
                      :disabled="SalvarDesativado"
                      color="#FF562B"
                      width="100%"
                      type="submit"
                      dark
                      >Salvar</v-btn
                    >
                  </v-col>
                  <!-- <v-col col="6" md="6" xl="6" sm="6">
                                <v-btn color="#FF562B" width="100%" dark @click="rota('cadastroaluno')">
                                <v-icon class="pr-2">mdi-arrow-left-bold-circle-outline</v-icon>Dados do Aluno</v-btn
                                >
                            </v-col>
                            <v-col col="6" md="6" xl="6" sm="6">
                                <v-btn color="#FF562B" width="100%" dark @click="rota('cadastrocontratoaluno')">
                                Contrato<v-icon class="ml-2">mdi-arrow-right-bold-circle-outline</v-icon></v-btn
                                >
                            </v-col> -->
                </v-row>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col col="12" md="12" xl="12" xs="12" sm="12">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="agendas"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:[`item.dia`]="{ item }">
              <span>
                {{ getDiaSemana(item.dia_semana) }}
              </span>
            </template>
            <template v-slot:[`item.hora`]="{ item }">
              <span>
                {{ formataHora(item.horario) }}
              </span>
            </template>
            <template v-slot:[`item.produto`]="{ item }">
              <AppProduto :value="item.produto" />
            </template>
            <template v-slot:[`item.observacao`]="{ item }">
              <v-tooltip top v-if="item.observacao" color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon medium class="mr-2" v-bind="attrs" v-on="on">
                    mdi-note-text-outline
                  </v-icon>
                </template>
                <span>{{ item.observacao }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.editar`]="{ item }">
              <v-icon medium class="mr-2" @click="editarAgenda(item)"> mdi-pencil-outline </v-icon>
            </template>
            <!-- <template v-slot:[`item.excluir`]="{ item }">
                            <v-icon
                            medium
                            style="align: center"
                            @click="excluirContrato(item.id)"
                            >
                            mdi-trash-can-outline
                            </v-icon>
                        </template>             -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import AppConfirma from '@/components/AppConfirma.vue';
import AppAlerta from '@/components/AppAlerta.vue';
import AppProduto from '@/components/AppProduto.vue';
import _aluno from '@/services/aluno/aluno-servico.js';
import _treinador from '@/services/treinador/treinador-servico.js';
import _agenda from '@/services/aluno/aluno-agenda-servico.js';
import _utils from '@/utils/utils.js';
// import _produto_horarios from "@/models/produto-horarios.js"
import _produtos from '@/models/produtos.js';
import _horarios from '@/models/produto-horarios.js';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    AppConfirma,
    AppProduto,
    AppAlerta,
  },
  data() {
    return {
      dialogs: {
        dialog: false,
        titulo: '',
      },
      snack: {
        snackbar: false,
        texto: '',
        cor: '',
      },
      editar: false,
      id: 0,
      treinadores: [],
      horariosTreinador: [],
      // horasDisponiveis: [],
      // diasDisponiveis: [],
      aluno: [],
      agendas: [],
      nome: '',
      treinador: '',
      carregandoHorariosTreinador: false,
      produtoSelecionado: null,
      produtosTreinador: [],
      diasemana: null,
      hora: '',
      horas: [],
      horariosIndisponiveis: true,
      treinadorDeselecionado: true,
      trinador_desativado: false,
      isDisabled: true,
      SalvarDesativado: true,
      observacao: '',
      dias: [
        { text: 'Segunda', value: 1 },
        { text: 'Terça', value: 2 },
        { text: 'Quarta', value: 3 },
        { text: 'Quinta', value: 4 },
        { text: 'Sexta', value: 5 },
        { text: 'Sábado', value: 6 },
      ],
      headers: [
        { text: 'Código', value: 'id' },
        { text: 'Dia da Semana', align: 'start', value: 'dia' },
        { text: 'Hora', value: 'hora' },
        { text: 'Treinador', value: 'treinador' },
        { text: 'Produto', value: 'produto' },
        { text: 'Observação', value: 'observacao' },
        { text: 'Editar', value: 'editar', align: 'center', sortable: false },
      ],
    };
  },

  mounted() {
    this.buscaTreinadores();
  },
  watch: {
    async treinador(novoId) {
      if (!novoId) return;

      this.carregandoHorariosTreinador = true;

      try {
        const data = await _treinador.agendaCompleta(novoId);
        this.horariosTreinador = data[0].horarios;

        if (this.editar) {
          this.treinadorDeselecionado = true;
          this.produtosTreinador = {
            id: this.produtoSelecionado,
            nome: _produtos[this.produtoSelecionado].text,
          };
        } else {
          this.produtosTreinador = this.treinadores
            .filter(t => t.id == novoId)
            .map(t => ({ id: t.produto, nome: _produtos[t.produto].text }));
          this.bloqueiaCampos();
          this.treinadorDeselecionado = false;
        }
      } catch (err) {
        console.error('Erro ao buscar horários:', err);
        this.horariosTreinador = {};
      } finally {
        this.carregandoHorariosTreinador = false;
      }
    },
    async produtoSelecionado(produtoId) {
      if (produtoId == null) return;
      console.log(produtoId);
      // Aguarda até que a flag indique que os horários estão prontos
      while (this.carregandoHorariosTreinador) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }

      const produtoHorarios = _horarios.produtoHorarios[produtoId];
      const horariosFiltrados = {};

      for (const dia in this.horariosTreinador) {
        if (produtoHorarios[dia]) {
          const horariosValidos = this.horariosTreinador[dia].filter(h =>
            produtoHorarios[dia].some(p => p.value === h.value)
          );
          if (horariosValidos.length > 0) {
            horariosFiltrados[dia] = horariosValidos;
          }
        }
      }

      const temHorarios = Object.keys(horariosFiltrados).length > 0;
      this.horariosTreinador = temHorarios ? horariosFiltrados : {};
      if (!this.editar) {
        this.diasemana = null;
        this.hora = null;
      }
      this.horariosIndisponiveis = !temHorarios;
    },
  },

  computed: {
    diasDisponiveis() {
      const nomes = {
        1: 'Segunda',
        2: 'Terça',
        3: 'Quarta',
        4: 'Quinta',
        5: 'Sexta',
        6: 'Sábado',
      };
      const dias = Object.keys(this.horariosTreinador).map(dia => ({
        text: nomes[dia],
        value: this.editar ? parseInt(dia) : dia,
      }));

      return dias;
    },
    horasDisponiveis() {
      return this.horariosTreinador[this.diasemana] || [];
    },
  },

  methods: {
    async buscaTreinadores() {
      if (this.$route.params.id != null) {
        await _aluno.buscarAluno(this.$route.params.id).then(response => {
          _aluno.buscarAlunoUsuario(response.usuario_id).then(response => {
            if (response.length == 0) {
              // this.pessoa = usuario_id
              // this.pessoa_aluno = { id: usuario_id, nome: this.$route.params.usuario.nome }
              // this.pessoaDesativada = true
            } else {
              this.alunos = response;
              this.alunos.forEach(aluno => {
                this.treinadores.push({
                  aluno_id: aluno.id,
                  id: aluno.treinador_id,
                  nome: aluno.treinador,
                  produto: aluno.produto,
                  tipoHorario: aluno.tipo_horario,
                });
              });
              this.aluno = response[0];
              this.aluno.id = this.$route.params.id;
              this.nome = this.aluno.nome;
              this.pessoa = this.aluno.usuario_id;
              this.pessoa_aluno = { id: this.aluno.usuario_id, nome: this.aluno.nome };
              this.pessoaDesativada = true;
              // _agenda.buscarProdutosTreinadores(this.aluno.usuario_id).then((response) => {
              //     console.log('produtos:',response)
              //     response.forEach((treinador) => {
              //         this.treinadores.push({
              //         id: treinador.id,
              //         nome: treinador.nome,
              //         produto: treinador.produto

              //         });
              //     });
              //     if(this.treinadores.length == 0){
              //     console.log('treinador->:',this.aluno.treinador)
              //     this.treinadores.push({
              //         id: this.aluno.treinador_id,
              //         produto: this.aluno.produto,
              //         nome: this.aluno.treinador,
              //     });
              // }
              // });

              this.listarAgenda(this.aluno.usuario_id);
              if (this.id == 0) {
                this.SalvarDesativado = false;
              }
            }
          });
        });
      } else {
        this.$router.push({ name: 'alunos' });
      }
    },
    buscar(id) {
      _aluno.buscarAluno(id).then(response => {
        this.aluno = response;
        this.nome = this.aluno.nome;
        this.treinador = this.aluno.treinador;
        this.observacao = this.aluno.observacao;
      });
    },
    listarAgenda(id) {
      _agenda.buscarAgenda(id).then(response => {
        this.agendas = response;
      });
    },
    async salvar() {
      //   if (this.aluno.treinador_id !== this.treinador) {
      //     console.log('mudou');
      //     await this.adicionaTreinadorSecundarioAgenda(this.treinador);
      //   } else {
      this.agenda = {
        aluno_id: this.getAlunoPeloTreinadorEProduto(this.treinador, this.produtoSelecionado),
        // aluno_id: this.getAlunoPeloProduto(this.produtoSelecionado),//estava dando erro quando era treinador secundario
        dia_semana: this.diasemana,
        horario: this.hora,
        treinador_id: this.treinador,
        observacao: this.observacao == null ? '' : this.observacao,
      };
      console.log(this.agenda);
      //   }
      if (this.id == 0) {
        this.salvarAgenda();
      } else {
        this.atualizar();
      }
    },
    salvarAgenda() {
      _agenda
        .salvarAgenda(this.agenda)
        .then(() => {
          this.snack.texto = 'Agenda salva com sucesso!';
          this.snack.snackbar = true;
          setTimeout(() => {
            this.listarAgenda(this.aluno.usuario_id);
          }, 500);
          this.limparCampos();
          this.bloqueiaCampos();
        })
        .catch(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Erro ao salvar agenda!';
          this.snack.cor = 'error';
        });
    },
    atualizar() {
      _agenda
        .atualizarAgenda(this.id, this.agenda)
        .then(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Agenda atualizada com sucesso!';
          this.snack.cor = 'success';
          setTimeout(() => {
            this.listarAgenda(this.aluno.usuario_id);
          }, 500);
          this.limparCampos();
          this.bloqueiaCampos();
        })
        .catch(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Erro ao atualizar agenda!';
          this.snack.cor = 'error';
        });
    },

    async adicionaTreinadorSecundarioAgenda(treinadorId) {
      this.alunos.forEach(aluno => {
        if (aluno.treinador_id == treinadorId) {
          this.agenda = {
            aluno_id: aluno.id,
            dia_semana: this.diasemana,
            horario: this.hora,
            treinador_id: this.treinador,
            observacao: this.observacao == null ? '' : this.observacao,
          };
        }
      });
    },
    editarAgenda(agenda) {
      this.editar = true;
      this.produtoSelecionado = agenda.produto;
      this.horariosIndisponiveis = false;
      this.treinadorDeselecionado = true;
      this.id = agenda.id;
      this.aluno.id = agenda.aluno_id;

      this.diasemana = agenda.dia_semana;
      this.hora = agenda.horario;
      this.observacao = agenda.observacao;
      (this.treinador = agenda.treinador_id),
        // verificar se não tem aulas para habilitar o excluir
        (this.isDisabled = false);
      this.trinador_desativado = true;
    },
    excluir() {
      this.dialogs.dialog = true;
      this.dialogs.titulo = 'Excluir Agenda';
      this.dialogs.mensagem = 'Deseja realmente excluir a agenda?';
    },

    getAlunoPeloTreinador(treinadorId) {
      return this.treinadores.find(treinador => treinador.id == treinadorId).aluno_id;
    },
    getAlunoPeloTreinadorEProduto(treinadorId, produto) {
      console.log({ treinadores: this.treinadores, treinadorId, produto });
      return this.treinadores.find(
        treinador => treinador.id == treinadorId && treinador.produto == produto
      ).aluno_id;
    },
    getProdutoPeloTreinador(treinadorId) {
      return this.treinadores
        .filter(treinador => treinador.id == treinadorId)
        .map(treinador => treinador.produto);
    },
    getAlunoPeloProduto(produtoId) {
      console.log({ produtoId });
      return this.alunos.find(aluno => aluno.produto == produtoId).id;
    },

    bloqueiaCampos() {
      this.treinadorDeselecionado = true;
      this.horariosIndisponiveis = true;
      this.produtoSelecionado = null;
      this.diasemana = null;
      this.hora = null;
    },

    getResposta(resposta) {
      if (resposta) {
        _agenda
          .excluirAgenda(this.id)
          .then(() => {
            this.dialogs.dialog = false;
            this.snack.snackbar = true;
            this.snack.texto = 'Agenda excluída com sucesso!';
            this.snack.cor = 'success';
            this.listarAgenda(this.aluno.usuario_id);
            this.limparCampos();
          })
          .catch(() => {
            this.dialogs.dialog = false;
            this.snack.snackbar = true;
            this.snack.texto = 'Erro ao excluir agenda!';
            this.snack.cor = 'error';
          });
      } else {
        this.dialogs.dialog = false;
      }
    },
    getDiaSemana(dia) {
      return _utils.diaSemana(dia);
    },
    formataHora(hora) {
      return _utils.formataHora(hora);
    },
    limparCampos() {
      this.id = 0;
      this.diasemana = null;
      this.hora = '';
      this.observacao = '';
      this.treinador = '';
      this.produtoSelecionado = null;
      this.treinadorDeselecionado = true;
      this.horariosIndisponiveis = true;
      this.trinador_desativado = false;
      this.editar = false;
      this.$refs.form.reset();
    },
    cancelar() {
      //this.rota('alunos')
      this.limparCampos();
    },
    rota(rota) {
      console.log('rota:', rota);
      this.$router.push({ name: rota, params: { aluno: this.aluno, tipo: 'Aluno' } });
    },
  },
};
</script>
